import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { PlacementAssets, PlacementAssetInformation } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PlacementAssetService {

  private path = '/placements';
  private assetPath = '/assets';

  constructor(private http: AlloxApiService) { }

  public get(id: number) {
    return this.http.get(this.path + '/' + id + this.assetPath).pipe(
      map(obj => new PlacementAssets(obj))
    );
  }

  public getDefault() {
    return this.http.get<[]>(this.path + this.assetPath + '/default').pipe(
      map(obj => new PlacementAssets(obj))
    );
  }

  public getAssetInformations() {
    return this.http.get<[]>(this.path + this.assetPath + '/information').pipe(
      map(objs => objs.map(obj => new PlacementAssetInformation(obj))));
  }

  public post(item: PlacementAssets) {
    const json = item.toJSON();
    return this.http.post(this.path + '/' + item.placementId + this.assetPath, json);
  }

  public put(item: PlacementAssets) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.placementId + this.assetPath, json);
  }
}
